import {observable,action} from 'mobx'
import {getVal,setVal} from '../../../utils/server'

//缓存报警规则
class UnhandledAlertStore{
  @observable checkAlert = getVal("checkAlert",{})

  @action setCheckAlert(checkAlert){
    this.checkAlert = checkAlert
    setVal("checkAlert",this.checkAlert)
  }
}

export default new UnhandledAlertStore()


// WEBPACK FOOTER //
// ./src/routes/Alert/unhandled-alerts/store.js